import { Select } from "antd";
import { useAuth } from "../context/AuthContext";
import useSetActiveBranch from "../hooks/useSetActiveBranch";

const BranchSelector = () => {
  const { user } = useAuth();
  const { changeActiveBranch, isLoading } = useSetActiveBranch();

  const handleBranchChange = (branchId) => {
    changeActiveBranch(branchId);
  };

  // Só esconder o select se não há filiais ou há apenas uma filial
  if (!user?.available_branches || user.available_branches.length < 2) {
    return null;
  }

  return (
    <div style={{ display: "flex", alignItems: "center", marginRight: 10 }}>
      <Select
        value={user.active_branch_id}
        onChange={handleBranchChange}
        loading={isLoading}
        style={{
          width: 200,
        }}
        placeholder="Selecione a filial"
        size="middle">
        {user.available_branches.map((branch) => (
          <Select.Option key={branch.id} value={branch.id}>
            {branch.name}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default BranchSelector;
